import { render, staticRenderFns } from "./UserPagination.vue?vue&type=template&id=c42728ac&"
import script from "./UserPagination.vue?vue&type=script&lang=js&"
export * from "./UserPagination.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/forge/staging.clcp.cliquedomains.com/web/app/themes/clc-portal/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c42728ac')) {
      api.createRecord('c42728ac', component.options)
    } else {
      api.reload('c42728ac', component.options)
    }
    module.hot.accept("./UserPagination.vue?vue&type=template&id=c42728ac&", function () {
      api.rerender('c42728ac', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/vue/Page/Directory/UserPagination.vue"
export default component.exports